<template>
  <div class="container fluid">

      <div>
        <h2>Welcome!</h2>
        <p>Enter an email address above to see if its information has been compromised.</p>
      </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h2{
  margin-top: 4rem;
}

</style>

<script>

export default {

}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue